<section class="p-6 flex flex-col gap-4">
  <h3 class="text-black font-black uppercase"> Lista de Abas do Dashboard </h3>

  <app-my-dashboard-list
    [dashboards]="dashboards"
    [dadosPaginacao]="dadosPaginacao"
    (mudouPagina)="mudouPagina($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    (recarregarListagem)="carregarDashboards()"
  ></app-my-dashboard-list>

  <hr class="mb-8" />
  <app-add-new-my-dashboard (recarregarListagem)="carregarDashboards()"></app-add-new-my-dashboard>
</section>
